var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-admin"
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto"
  }, [_c('div', {
    staticClass: "mb-6 relative"
  }, [_vm.image ? _c('div', {}, [_c('div', {
    staticClass: "border overflow-hidden rounded-full flex justify-center items-center w-32 h-32 text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })])]) : _c('div', {
    staticClass: "image-upload"
  }, [_c('input', {
    ref: "photo",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "name": "photo",
      "id": "photo",
      "accept": ".jpg, .png, .jpeg"
    },
    on: {
      "change": function ($event) {
        return _vm.handleFileSelect($event);
      }
    }
  }), _c('label', {
    staticClass: "border border-dashed p-6 rounded-full flex justify-center items-center border-neutral-500 text-neutral-500 w-32 h-32 text-center cursor-pointer",
    attrs: {
      "for": "photo"
    }
  }, [_vm._v(" Upload Photo ")])])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama",
      "placeholder": "Nama"
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6 relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 block"
  }, [_vm._v("Jenis Kelamin")]), _c('div', {
    staticClass: "flex items-center pl-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.gender,
      expression: "gender"
    }],
    staticClass: "cursor-pointer",
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "M",
      "name": "gender"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "M")
    },
    on: {
      "change": function ($event) {
        _vm.gender = "M";
      }
    }
  }), _c('label', {
    staticClass: "text-sm pl-2 cursor-pointer",
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Laki-laki")])]), _c('div', {
    staticClass: "flex items-center pl-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.gender,
      expression: "gender"
    }],
    staticClass: "cursor-pointer",
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "F",
      "name": "gender"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "F")
    },
    on: {
      "change": function ($event) {
        _vm.gender = "F";
      }
    }
  }), _c('label', {
    staticClass: "text-sm pl-2 cursor-pointer",
    attrs: {
      "for": "two"
    }
  }, [_vm._v("Perempuan")])])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Email",
      "placeholder": "Alamat Email"
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "label": "No Handphone",
      "placeholder": "No Handphone"
    },
    model: {
      value: _vm.phoneNumber,
      callback: function ($$v) {
        _vm.phoneNumber = $$v;
      },
      expression: "phoneNumber"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Partner")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.partnerList,
      "placeholder": "Pilih partner",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedPartner,
      callback: function ($$v) {
        _vm.selectedPartner = $$v;
      },
      expression: "selectedPartner"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 mdmax:w-full mdmax:flex-auto p-6"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Username"
    },
    model: {
      value: _vm.username,
      callback: function ($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Password"
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Role")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.roleList,
      "placeholder": "Pilih partner",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedRole,
      callback: function ($$v) {
        _vm.selectedRole = $$v;
      },
      expression: "selectedRole"
    }
  })], 1)])]), _c('div', {
    staticClass: "w-full bg-white p-6"
  }, [_c('div', {
    staticClass: "flex gap-6 justify-end"
  }, [_c('div', {}, [_c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "type": "primary"
    },
    on: {
      "action": function ($event) {
        return _vm.save();
      }
    }
  })], 1)])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }